import Util from '../../../../utils/util';
import Global from '../../../../utils/global';
import Constants from '../../../../utils/constants';
import {postMessage, onMessage, removeOnMessage} from '../../../../utils/event-bus';
// import {loginApi, checkAfrApi, casLogoutApi, casAuthentication, casAuthenticationLogin, casUpLogin, getHomePage, getMapCenterPoint, getAuthority, getJwtToken} from '../../../service/login.js';
import {loginApi, checkAfrApi, casLogoutApi, casAuthentication, casAuthenticationLogin, casUpLogin, getHomePage, getMapCenterPoint, getAuthority, getJwtToken, getJwtTokenByCode, opLog} from '../../../service/login.js';

import Auth from '../../../../utils/auth';

export default {
  props: {
    customize: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      isGlobalInit: false,
      tryCount: 0,
      loading: false,
      isOpenedBefore: false,
      casLoginType: '',
      isLogined: true, //用于判断是否已经登录过，如果已经登录过，执行关闭窗口
      models: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {required: true, message: '用户名不能为空', trigger: 'blur'}
        ],
        password: [{required: true, message: '密码不能为空', trigger: 'blur'}]
      },
      rememberUser: false, // 记住密码
      forceUpdatePwd: false // 是否显示修改密码弹框
    };
  },
  methods: {
    handlePwdUpdated(res) {
      console.log('handlePwdUpdated --------- ', res);
      Auth.clearJwtToken();
      this.forceUpdatePwd = false;
      this.models.password = '';
    },
    tryToCloseCurrentTab(){
      setTimeout(() => {
        !Auth.getUserOnline() && Util.closeCurrentTab();
      }, 200);
    },
    userLogin() {
      if(!this.models.username){
        this.$message({message: '用户名不能为空', type: 'error'});
      }else if(!this.models.password){
        this.$message({message: '密码不能为空', type: 'error'});
      }else if (this.models.username && this.models.password && !this.loading) {
        this.loading = true;
        Auth.setRememberUser(this.rememberUser);
        let params = Util.clone(this.models);
        if(Global.getCustomConfig()['CAS_LOGIN'] === 'CHECK_AFR'){
          checkAfrApi(params).then(result => {
            if(result === true){ //必须人脸登录
              this.casLogin();
            } else {
              this.pwdLogin(params);
            }
          }).catch((err) => {
            console.error('checkAfrApi err', err);
            this.loading = false;
          });
        }else{
          this.pwdLogin(params);
        }
      }
    },
    pwdLogin(params){
      loginApi(params).then(result => {
        if (result && result.jwt_token) {
          Auth.clearStorage();
          Auth.online();
          Auth.setJwtToken(result.jwt_token);
          Auth.setRefreshToken(result.refresh_token);
          Global.init().then(res => {
            // 获取个人主页的设置
            this.isGlobalInit = true;
            console.log('Global.getCustomConfig()>>>', Global.getCustomConfig());
            if(this.models.username){
              let userinfo = Util.clone(this.models);
              userinfo.password = Util.encrypt(this.models.password);
              userinfo.logintime = Util.formatDateTime(new Date().getTime(), 'YYYYMMDDHHMISS');
              userinfo.expiresIn = result.expires_in;//过期时间
              Auth.setUserInfo(userinfo);
            }
            if(Global.getCustomConfig()['CAS_SESSION']){
              this.casSession();
            }
            if(Global.getCustomConfig()['KIAF_MAP_CENTER_POINT'] === 'Y'){
              getMapCenterPoint().then(response => {
                // let extendedField = response.extendedField;
                // if(extendedField){
                //   try{
                //     let extendedFieldJson = JSON.parse(extendedField);
                //     Global.addStorage(Constants.STORAGE_KEY_MAP_CENTER_POINT, extendedFieldJson.center);
                //   }catch(e){
                //     Global.addStorage(Constants.STORAGE_KEY_MAP_CENTER_POINT, []);
                //   }
                // }else {
                //   Global.addStorage(Constants.STORAGE_KEY_MAP_CENTER_POINT, []);
                // }
                let { xMin, xMax, yMin, yMax } = response;
                if(xMin && xMax && yMin && yMax) {
                  let jd = (xMin + xMax) / 2;
                  let wd = (yMin + yMax) / 2;
                  Global.addStorage(Constants.STORAGE_KEY_MAP_CENTER_POINT, [jd, wd]);
                } else {
                  let extendedField = response.extendedField;
                  if (extendedField) {
                    try {
                      let extendedFieldJson = JSON.parse(extendedField);
                      Global.addStorage(Constants.STORAGE_KEY_MAP_CENTER_POINT, extendedFieldJson.center);
                    } catch (e) {
                      Global.addStorage(Constants.STORAGE_KEY_MAP_CENTER_POINT, []);
                    }
                  } else {
                    Global.addStorage(Constants.STORAGE_KEY_MAP_CENTER_POINT, []);
                  }
                }
                this.tryToGetHomePage(result);
              }).catch(err => {
                console.error('getMapCenterPoint>>>', err);
                this.tryToGetHomePage(result);
              });
            } else {
              this.tryToGetHomePage(result);
            }
          });
        } else {
          this.loading = false;
          let message = result.message;
          if(this.customize.dynaMessage && message){
            this.$alert(message, '警告', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          } else {
            this.$alert('用户名或密码错误！', '警告', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        }
      }).catch((err) => {
        console.error('login api err', err);
        this.loading = false;
      });
    },
    async casSession() {
       await casAuthentication({});
       await casUpLogin(this.models);
       await casAuthenticationLogin({});
    },
    async casLogin () {
      if(this.models.username){
        sessionStorage.setItem('kiaf_username', this.models.username);// 与统一权限李泽鹏约好通过sessionStorage的kiaf_username与统一权限传递用户名
      }
      let protocol = Global.getCustomConfig()['KIAF_LOCATION_PROTOCOL'] || window.location.protocol;
      let locationUrl = window.location.host + window.location.pathname;
      if(this.$constants.HOME_PAGE_LOGIN != '/#/'){
        locationUrl += this.$constants.HOME_PAGE_LOGIN;
      }
      locationUrl = locationUrl.replace('//', '/');
      locationUrl = protocol + '//' + locationUrl;
      const CURRENT_URL = encodeURIComponent(locationUrl + '?type=cas');
     let returnUri = encodeURIComponent(`${Global.getBaseUrl()}/oauth2/authorize?json=0&returnUri=${CURRENT_URL}`);
     let caslogoutUrl = `${Global.getBaseUrl()}`;
     if(Global.getCustomConfig()['LOGOUT_URL']){
       caslogoutUrl = Global.getCustomConfig()['LOGOUT_URL'];
       window.location.href = `${caslogoutUrl}/auth/logout?json=0&returnUri=${returnUri}`;
     } else if(Global.getCustomConfig()['CAS_SERVER_URL']){
       let redirectUrl = Global.getCustomConfig()['CAS_SERVER_URL'].replace('#returnUri#', returnUri);
        window.location.href = redirectUrl;
    } else {
       let params = {
         json: 0
       };
       await casLogoutApi(params);
       //https://dolphin-dev.kedacom.com/kiaf-server/oauth2/authorize?json=0&returnUri=http%3A%2F%2Flocalhost%3A8080%2F%3Ftype%3Dcas
       //https://dolphin-dev.kedacom.com/ezview-backend-xm/ezview/oauth2/authorize?json=0&returnUri=http%3A%2F%2Flocalhost%3A8080%2F%3Ftype%3Dcas
       window.location.href = `${Global.getBaseUrl()}/oauth2/authorize?json=0&returnUri=${CURRENT_URL}`;
     }
    },
    onlyCasLogin(){
      return this.casLoginType == 'ONLY';
    },
    bothCasLogin(){
      return this.casLoginType === 'BOTH' || this.casLoginType === 'CHECK_AFR';
    },
    isCasLogin() {   //统一登录功能
      const CURRENT_URL = window.location.href;
      if (CURRENT_URL.includes('code=')) { //含有该字符串即为cas登录后跳转过来的
        let query = this.$route.query;
        Auth.clearStorage();
        // 获取当前登录用户的token，用于后面接口的ajax
        Global.init().then(ret => {
          getJwtTokenByCode(query).then(res => {
            let result = res.data;
            Auth.setJwtToken(result.jwt_token);
            Auth.setRefreshToken(result.refresh_token);
            getAuthority().then(authData => {
              if (authData.status) {
                this.$message.error('统一登录失败，请使用用户名密码登录');
                return;
              }
              Auth.setUserInfo({
                username: authData.user.username,
                password: '',
                name: authData.user.name,
                userunit: authData.user.deptName,
                user: authData.user
              });
              this.tryToGetHomePage(result, true); // 根据配置，获取首页地址并进行跳转
            });
          });
        });
      } else if (CURRENT_URL.includes('type=cas')) { //含有该字符串即为cas登录后跳转过来的
        getAuthority().then(authData => {
          if (authData.status) {
            this.$message.error('统一登录失败，请使用用户名密码登录');
            return;
          }
          Auth.clearStorage();
          Auth.setUserInfo({
            username: authData.user.username,
            password: '',
            name: authData.user.name,
            userunit: authData.user.deptName,
            user: authData.user
          });
          // 获取当前登录用户的token，用于后面接口的ajax
          Global.init().then(ret => {
            this.isGlobalInit = true;
            getJwtToken().then(res => {
              Auth.setJwtToken(res.jwt_token);
              Auth.setRefreshToken(res.refresh_token);
              this.tryToGetHomePage(res, true); // 根据配置，获取首页地址并进行跳转
            });
          });
        });
      } else if(Global.getCustomConfig()['CAS_LOGIN'] === 'ONLY'){
        this.casLogin();
        // let protocol = Global.getCustomConfig()['KIAF_LOCATION_PROTOCOL'] || window.location.protocol;
        // let locationUrl = protocol + '//' + window.location.host + window.location.pathname;
        // const CURRENT_URL = encodeURIComponent(locationUrl + '?type=cas');
        // window.location.href = `${Global.getBaseUrl()}/oauth2/authorize?json=0&returnUri=${CURRENT_URL}`;
      }else {
        this.casLogout();
      }
    },
    casLogout(){
      if(Global.getCustomConfig()['LOGOUT_URL']){
        let iframe = document.createElement('iframe');
        const returnUri = encodeURIComponent(location.origin + location.pathname);
        let url = `${Global.getBaseUrl()}/auth/logout?json=0&returnUri=${returnUri}`;
        url = `${Global.getCustomConfig()['LOGOUT_URL']}/auth/logout?json=0&returnUri=${returnUri}`;
        iframe.setAttribute('src', url);
        iframe.setAttribute('width', 0);
        iframe.setAttribute('height', 0);
        iframe.setAttribute('style', 'display:none');
        document.body.appendChild(iframe);
        iframe.onload = () => {
          console.log('iframe onload');
          document.body.removeChild(iframe);
        };
      } else {
        let params = {
          json: 0
        };
        casLogoutApi(params);
      }
    },
    async tryToGetHomePage(result, isCasLogin = false){
      if(this.customize.handleUserLogin && typeof this.customize.handleUserLogin === 'function'){
        await this.customize.handleUserLogin();
      }
      // 非 CAS 登录，且不跳过登录 的情况下，获取用户信息，检查密码
      // CAS 登录的情况下，在执行到这一步之前已经获取过用户信息了
      if(!isCasLogin && !Global.isSkipLogin()){
        let user = await Auth.getUser();
        let userInfo = Auth.getUserInfo();
        userInfo.code = user.code; // 将 code 保存在登录信息中
        Auth.setUserInfo(userInfo);
        if (Global.getCustomConfig()['KIAF_FORCE_UPDATE_PWD'] === 'Y') { // 配制中强制要求修改默认密码
          // 如果当前用户的密码 和 code 一样，表示未设置过自己的密码，停止跳转，提示修改密码
          if (user.code === this.models.password) {
            this.loading = false; // 停止 loading
            this.forceUpdatePwd = true; // 显示修改密码弹框
            return;
          }
        }
      }
      if(Global.isStaticHomePage()){
        this.loading = false;
        this.nextPage(result);
      } else {
        getHomePage().then(ret => {
          this.loading = false;
          console.log(ret, '获取个人主页的设置获取个人主页的设置获取个人主页的设置');
          if (ret.businessHomepageUrl) {
            // 如果主页存在就设置主页
            let windows = Global.getWindows();
            for(let i = 0; i < windows.length; i++){
              if(windows[i].type == 'business' || (!windows[i].type && i == 0)){
                windows[i].url = ret.businessHomepageUrl;
                if(ret.businessHomepageUrl.indexOf('http://') >= 0 || ret.businessHomepageUrl.indexOf('https://') >= 0){
                  windows[i].url = '/kiaf/internalPage';
                  let webviewPage = {
                    id: new Date().getTime(),
                    title: ret.businessHomepage,
                    url: ret.businessHomepageUrl
                  };
                  Global.addStorage(Constants.STORAGE_KEY_WEBVIEW_PAGE, webviewPage);
                }
              }
            }
            Global.setWindows(windows);
          }
          this.nextPage(result);
        }).catch(err => {
          console.error('getHomePage>>>', err);
          this.nextPage(result);
        });
      }
    },
    closeWin() {
      if (Global.isPopUp()) {
        if(Global.isPreloadMode() && Util.isInstalledChromeExtension() && Util.isChromeExtensionWindow()){
          //
        } else {
          if (Util.isInstalledChromeExtension() && !Util.isChromeExtensionWindow()) {
            Util.closeCurrentTab();
            window.close();
            window.location.href = 'about:blank';
          } else {
            Util.closeAllWindow(true);
          }
        }
      } else {
        window.close();
        window.location.href = 'about:blank';
      }
    },
    async nextPage(result){
      Auth.setJwtToken(result.jwt_token);
      Auth.setRefreshToken(result.refresh_token);
      // await Auth.kickUserOtherClient();
      const tasks = [];
      tasks.push(Auth.kickUserOtherClient()); // 剔除其他用户
      if(this.$global.getCustomConfig()['KIAF_ONLINE_NUMBER']){
        tasks.push(this.loginLog()); // 记录登录日志
      }
      for (let tIndex = 0; tIndex < tasks.length; tIndex++) { await tasks[tIndex]; }

      this.loading = false;
      let key1 = Constants.STORAGE_KEY_REDIRECT_URL + '_' + Auth.getUserInfo().username;
      let key2 = Constants.STORAGE_KEY_REDIRECT_URL;
      let redirectUrl = sessionStorage.getItem(key1) || sessionStorage.getItem(key2) || '';
      if(redirectUrl){
        sessionStorage.removeItem(key1);
        sessionStorage.removeItem(key2);
        if(Util.isIE()){
          this.$router.push({
            path: redirectUrl
          });
        } else {
          location.href = Util.getFullUrl(redirectUrl);
        }
        return;
      }
      if (Global.isPopUp()) {
        if(!this.isOpenedBefore){
          this.isOpenedBefore = true;//避免重复open window
          Util.openWindows(Global.getWindows());
          if(Util.isInstalledChromeExtension()){
            let primaryWin = Global.getPrimaryWindow();
            setTimeout(() => {
              Util.switchWindow(primaryWin.windowId, null, null, true);
            }, 500);
          }
        }
      } else {
        let windows = Global.getWindows();
        if (windows.length > 0) {
          // location.href = Util.getFullUrl(windows[0].url);
          let homepage = windows[0].url;
          if(homepage.indexOf('#') >= 0){
            homepage = homepage.split('#')[1];
          }
          if (windows.length == 2) {
            Util.openWindows(Global.getWindows(), false);
            this.closeWin();
          } else {
            window.name = windows[0].windowId;
            location.replace(Util.getFullUrl(homepage));
            // this.$router.push({
            //   path: homepage
            // });
          }
        }
      }
    },
    loginLog(){
      const user = Auth.getUserInfo();
      opLog({
        'logDescription': '用户登录',
        'logType': '登录日志',
        'operateModule': '登录',
        'userName': user.username,
        'operateType': '查询'
      }).then(res => {
        console.log('loginLog res', res);
      }).catch(err => {
        console.error('loginLog err', err);
      });
    },

    // 修改密码
    savePassword() {
      if (this.$refs['updatePwd']) {
        this.$refs['updatePwd'].savePwd();
      }
    }
  },
  created() {
    this.casLoginType = Global.getCustomConfig()['CAS_LOGIN'];
    if (!this.customize) {
      this.customize = {};
    }
    if (!this.customize.images) {
      this.customize.images = {};
    }
    if (!this.customize.labels) {
      this.customize.labels = {};
    }
    if (!this.customize.labels.casLogin) {
      this.$set(this.customize.labels, 'casLogin', 'UKey登录');
    }
    if (!this.customize.labels.subject) {
      this.$set(this.customize.labels, 'subject', '欢迎登录');
    }
    if (!this.customize.labels.copyright) {
      this.$set(this.customize.labels, 'copyright', '版权所有 © 1995-2021 苏州科达科技股份有限公司');
    }
    postMessage(Constants.EVENT_BUS_CODE_PRELOAD_CLOSE_LOGIN_WIN, {}, null, true);
    if(Global.getCustomConfig()['KIAF_LOCATION_PROTOCOL'] && window.location.protocol != Global.getCustomConfig()['KIAF_LOCATION_PROTOCOL']){
      window.location.href = Util.getFullUrl(Constants.WIN_LOGIN);
    }
    if(Global.getCustomConfig()['CAS_LOGIN']){
      this.isCasLogin();
    }

    this.$store.commit('KIAF_INIT_VUEX');
    this.rememberUser = Auth.getRememberUser();
    if (this.rememberUser) {
      this.models.username = Auth.getUserInfo().username;
      this.models.password = Util.decrypt(Auth.getUserInfo().password);
    }
    if (Util.isOpenedWindow()) {
      this.isLogined = false;
    } else {
      postMessage(Constants.EVENT_BUS_CODE_CHECK_LOGINED, {status: true}, null, true);
      onMessage(Constants.EVENT_BUS_CODE_CHECK_LOGINED_CALLBACK, (data) => {
        this.isLogined = true;
        this.$alert('请不要重复打开应用', '警告', {
          confirmButtonText: '确定',
          callback: action => {
            this.closeWin();
          }
        });
      }, this);
    }
    if(this.$global.isPopUp()){
      let callbackCount = 0;
      onMessage(Constants.EVENT_BUS_CODE_CLOSE_LOGIN_WIN, () => {
        callbackCount++;
        if (callbackCount >= Global.getWindows().length) {
          this.closeWin();
        }
      }, this);
    }
    //绑定enter键登陆
    document.onkeydown = (event) => {
      let messageBoxWrapper = document.querySelector('.kc-message-box__wrapper');
      console.log('messageBoxWrapper>>>', messageBoxWrapper);
      let noModal = !messageBoxWrapper || messageBoxWrapper.style.display == 'none';
      let e = event || window.event;
      if (e && e.keyCode == 13 && noModal) {
        this.userLogin();
      }
    };

    if(Global.isPopUp() && Global.isPreloadMode()){
      setTimeout(() => {
        this.isLogined = false;
        if(Util.isInstalledChromeExtension() && !Util.isChromeExtensionWindow() && !Auth.getUserOnline()){ //插件模式下，如果在浏览器中打开，则直接通过插件打开登录页面
          let primaryWin = Global.getPrimaryWindow();
          primaryWin.url = Constants.HOME_PAGE_LOGIN + '?primaryWin=Y';
          let wins = [];
          wins.push(primaryWin);
          Util.openWindows(wins);
          onMessage(Constants.EVENT_BUS_CODE_PRELOAD_CLOSE_LOGIN_WIN, () => { //不是插件打开的窗口才会关闭
            this.tryToCloseCurrentTab();
          }, this);
        }
      }, 500);
    } else {
      setTimeout(() => {
        this.isLogined = false;
      }, 500);
    }

    if(!Util.isChromeExtensionWindow()){
      Auth.clearCache();
      Util.requestChromeExtScreens();
    }
    window.onmessage = (message) => {
       console.log('message.data>>>', message.data);
      if(message.data && message.data.action === 'CHROME_EXT_CHANGE_PAGE'){
        console.log('message.data.message.data.url>>>', message.data.message.data.url);
        location.href = message.data.message.data.url;
      }else if(message.data && message.data.action === 'CHROME_EXT_GET_SCREENS'){
        console.log('message.data.action>>>', message.data.action);
        console.log('message.data.message.value>>>', message.data.message.value);
        Global.setScreenCount(message.data.message.value.length);
        if(message.data.message.value.length >= 2 && Global.getInitWindows().length >= 2 && Global.isPreloadMode() && !Util.isChromeExtensionWindow() && !Auth.getUserOnline()){
            let windows = Global.getNoPrimaryWindows();
            windows.forEach(win => {
              win.url = Constants.HOME_PAGE_LOGIN;
            });
            Util.openWindows(windows);
        }
      }
    };
  },
  mounted() {
    // 清除失效的日志数据，延迟500毫秒是为了保证 Logger 已经链接数据库
    setTimeout(() => {
      this.$logger.deleteExpiredLogs();
    }, 500);
  },
  beforeDestroy() {
    this.models.username = '';
    this.models.password = '';
    removeOnMessage(Constants.EVENT_BUS_CODE_CHECK_LOGINED_CALLBACK, this);
    removeOnMessage(Constants.EVENT_BUS_CODE_CLOSE_LOGIN_WIN, this);
    if(!this.isGlobalInit){ //preloadmode模式下，出现两个登录页面，一个页面登录后，另外一个页面直接跳转会出现无法初始化的情况
      Global.init().then(res => {
        this.isGlobalInit = true;
      });
    }
    document.onkeydown = null;
  },
  beforeUnmount() {
    this.models.username = '';
    this.models.password = '';
    removeOnMessage(Constants.EVENT_BUS_CODE_CHECK_LOGINED_CALLBACK, this);
    removeOnMessage(Constants.EVENT_BUS_CODE_CLOSE_LOGIN_WIN, this);
    if(!this.isGlobalInit){ //preloadmode模式下，出现两个登录页面，一个页面登录后，另外一个页面直接跳转会出现无法初始化的情况
      Global.init().then(res => {
        this.isGlobalInit = true;
      });
    }
    document.onkeydown = null;
  }
};
